import { boolean, nullable, optional } from "valibot"

export const BooleanSchema = boolean()
export const NullableBooleanSchema = nullable(BooleanSchema)
export const OptionalNullableBooleanSchema = optional(NullableBooleanSchema)
